module.exports = __webpack_public_path__ + "static/media/monitor.e7da2163.svg";